import { cssVar } from 'src/app/styles/helper';
import { RadiusPropKeys } from 'src/app/styles/spacing';
import styled, { css } from 'styled-components';

interface AssetWrapperProps {
  $maxWidth?: string | number;
  $type?: 'image' | 'video';
  $radius?: RadiusPropKeys;
  $cover?: boolean;
}

const videoStyles = css<AssetWrapperProps>`
  > video {
    ${({ $cover }) =>
      !$cover
        ? ''
        : css`
            width: 100%;
            height: 100%;
            object-fit: cover;
          `}
  }
`;

const imageStyles = css<AssetWrapperProps>`
  ${({ $cover }) =>
    $cover
      ? css`
          width: 100%;
          height: 100%;
          object-fit: cover;

          img,
          .gatsby-image-wrapper {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        `
      : ''}
`;

export const AssetWrapperContainer = styled.div<AssetWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: fit-content;
  border-radius: ${(props) => (props.$radius ? cssVar(props.$radius) : 'unset')};
  max-width: ${(props) => {
    if (typeof props.$maxWidth === 'number') {
      return `${props.$maxWidth}px`;
    }

    return props.$maxWidth || '100%';
  }};
  ${({ $type }) => ($type === 'video' ? videoStyles : imageStyles)}
`;
